"use strict";

exports.__esModule = true;
exports.DeviceTypeListContext = void 0;
var _Utils = require("../../../Utils");
/**
 * Provides a list of devices to consumers.
 *  @component
 **/

var DeviceTypeListContext = exports.DeviceTypeListContext = (0, _Utils.createEnhancedContext)({
  propName: "deviceTypes"
});